import { CompanyCreateInput, CompanyUpdateInput } from "../../api";
import { builder } from "../builder";

builder.input<CompanyCreateInput>("CompanyCreateInput", {
  name: builder.string().required(),
});

builder.input<CompanyUpdateInput>("CompanyUpdateInput", {
  active: builder.boolean().nullable(),
  name: builder.string().nullable(),
});
